'use client';
import { useReducer } from 'react';

const useStateMachine = (initialState, machine)=>{
    return useReducer((state, event)=>{
        const nextState = machine[state][event];
        return nextState != null ? nextState : state;
    }, initialState);
};

export { useStateMachine };
//# sourceMappingURL=useStateMachine.js.map
